import { FadedImage } from "../../FadedImage";

const A = "/brand";
const IMG = `${A}/blueprint4joy-about-coral-hat.jpg`;
const ALT = "Lara mid video call in her living room, coral trucker hat, colorful art and pillows around her.";

export function AboutHero() {
  return (
    <section data-testid="about-hero" className="relative overflow-hidden bg-[#FAFAF8]">
      <div className="relative w-full overflow-hidden reveal pb-[45px] lg:pb-[45px]">
        {/* Desktop image half-band, right side, bleeds to outer/top/bottom edge */}
        <div className="hidden lg:block absolute inset-y-0 right-0 w-[52%]">
          <FadedImage
            src={IMG}
            alt={ALT}
            testId="about-hero-image"
            bg="#FAFAF8"
            objectPosition="50% 22%"
            featherLeft={40}
            featherTop={9}
            featherBottom={9}
            className="absolute inset-0"
          />
        </div>

        {/* Mobile image stacked on top */}
        <div className="lg:hidden relative w-full aspect-[4/3] mt-6">
          <FadedImage
            src={IMG}
            alt={ALT}
            testId="about-hero-image-mobile"
            bg="#FAFAF8"
            objectPosition="50% 20%"
            featherBottom={19}
            className="absolute inset-0"
          />
        </div>

        {/* Text on the clean left */}
        <div className="relative z-[2] max-w-7xl mx-auto px-6 md:px-10 pt-10 lg:pt-0 flex items-center lg:min-h-[min(78vh,680px)]">
          <div className="w-full lg:w-[52%] lg:translate-x-[4%]">
            <div className="max-w-[520px]">
              <h1
                data-testid="about-hero-headline"
                className="font-display text-[37px] sm:text-[50px] lg:text-[59px] leading-[1.14] tracking-tight text-[#1C1917]"
              >
                What do you do?
              </h1>
              <div className="mt-7 space-y-4 text-[24px] md:text-[26px] leading-relaxed text-[#57534E]">
                <p>
                  I&rsquo;d rather know what lights you up&hellip;
                  <br />
                  &hellip;or what used to.
                </p>
                <p>
                  And the{" "}
                  <span
                    data-testid="about-hero-impossible-dream"
                    className="text-[26px] md:text-[28px] font-medium text-[#1C1917]"
                  >
                    impossible dream
                  </span>{" "}
                  you barely whisper to yourself in the shower.
                </p>
              </div>
              <p
                data-testid="about-hero-ps"
                className="mt-6 text-sm italic text-[#57534E]/80"
              >
                p.s. My r&eacute;sum&eacute; is on LinkedIn.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
